import { useGoalTaskProgress as _useGoalTaskProgress } from '@griply/hooks';
import { Goal, Timestamp } from '@griply/types';
import { useSubGoals } from 'features/goals';
import { useTasks } from 'features/tasks';

export type UseGoalTaskProgressOptions = {
  startDate: Timestamp;
  endDate: Timestamp;
};

export const useGoalTaskProgress = (
  goal: Goal,
  { startDate, endDate }: UseGoalTaskProgressOptions,
) => {
  const subGoals = useSubGoals(goal.id);
  const allTasks = useTasks(
    { goals: [goal.id, ...subGoals.map(({ id }) => id)] },
    !!goal.id,
  );

  return _useGoalTaskProgress(goal, { startDate, endDate, allTasks });
};
